<main class="w-full show">
	<lbca-input-text
		[maskInput]="fieldProps.mask"
		[label]="labelValue"
		[disabled]="true"
		[referenced]="true"
		[value]="entityValue"
	></lbca-input-text>
</main>
